import * as _ from 'lodash';
import { RouteError } from '@foxbun/lib-errors';
export class AbstractClient {
    options;
    _requests;
    constructor(options) {
        this.options = options;
        this._requests = new Set();
    }
    path(p) {
        return `${this.options.url}${p}`;
    }
    async post(args) {
        if (args.buffered) {
            let existing = this._requests.values().find((r) => args.path == r.path && _.isEqual(args.params, r.params));
            if (!existing) {
                existing = {
                    path: args.path,
                    params: args.params,
                    promise: this._post(args).finally(() => {
                        setTimeout(() => {
                            this._requests.delete(existing);
                        }, 100);
                    })
                };
                this._requests.add(existing);
            }
            return existing.promise;
        }
        return this._post(args);
    }
    async _post(args) {
        let headers = {};
        if (args.token) {
            headers = {
                ...headers,
                Authorization: `Bearer ${args.token}`
            };
        }
        if (args.req) {
            headers = {
                ...headers,
                'Content-Type': `application/json`
            };
        }
        if (args.res) {
            headers = {
                ...headers,
                Accept: `application/json`
            };
        }
        let res = await fetch(`${this.path(args.path)}`, {
            method: 'POST',
            ...(args.req
                ? {
                    body: JSON.stringify(args.req.encode(args.params))
                }
                : {}),
            headers: headers
        });
        if (res.status !== 200) {
            try {
                let response = await res.json();
                if (response?.error?.code) {
                    throw new RouteError({
                        ...response.error,
                        response_code: res.status
                    });
                }
            }
            catch (ex) {
                if (ex instanceof RouteError) {
                    throw ex;
                }
            }
            throw Error(`Request failure [${res.status}]`);
        }
        if (args.res) {
            let response = await res.json();
            return args.res.decode(response);
        }
        return undefined;
    }
}
